import TeamStatsLayout from 'layouts/team-stats.layout';
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import LogisticsStatsPageOne from './logistics-stats-page-one';
import LogisticsStatsPageTwo from './logistics-stats-page-two';
import LogisticsStatsPageThree from './logistics-stats-page-three';
import './style.scss';
import LogisticsStatsPageFour from './logistics-stats-page-four';
import LogisticsStatsPageFive from './logistics-stats-page-five';
import LogisticsStatsPageSix from './logistics-stats-page-six';
import LogisticsStatsPageSeven from './logistics-stats-page-seven';
import LogisticsStatsPageEight from './logistics-stats-page-eight';
import LogisticsStatsPageNine from './logistics-stats-page-nine';
import { apiService } from 'utils/api';
import { SocketIOConnection } from 'utils/socket_client';

export type OrderStat = {
  average_delivery_time: number;
  average_delivery_time_increase: string;
  completed_order_count: string;
  completed_order_increase: string;
  failed_order_count: string;
  failed_order_increase: string | null;
  failed_order_percentage: string;
  prev_failed_order_count: string;
  prev_success_order_count: string;
  success_order_count: string;
  success_order_increase: string;
  success_order_percent: string;
};
const LogisticsTeamStats = () => {
  const [data, setData] = useState<OrderStat>({} as OrderStat);
  const [loading, setLoading] = useState<boolean>(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await apiService.post('logistics/team-order-stat', {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      setData(res?.data.data);
    } catch (err: any) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const connectSocket = async () => {
    const conn = await SocketIOConnection.getConnection();
    conn.onReconnect(async () => {
      conn.joinRoom(roomName, process.env.REACT_APP_WEBOCKETAPP_KEY);
      const res: any = await fetchData();
      setData(res);
    });

    const roomName = 'logistics-order-stat';
    conn.addEventListener(roomName, 'update', (data: any) => {
      setData(data);
    });
    conn.joinRoom(roomName, process.env.REACT_APP_WEBOCKETAPP_KEY);
  };
  useEffect(() => {
    fetchData();
    connectSocket();
  }, []);
  const Settings = {
    infinite: true,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false
  };

  return (
    <TeamStatsLayout>
      <Slider {...Settings} className='stats_slider'>
        <div>
          <LogisticsStatsPageOne data={data} loading={loading} />
        </div>
        <div>
          <LogisticsStatsPageTwo data={data} loading={loading} />
        </div>
        <div>
          <LogisticsStatsPageThree />
        </div>
        <div>
          <LogisticsStatsPageFour />
        </div>
        <div>
          <LogisticsStatsPageFive />
        </div>
        <div>
          <LogisticsStatsPageSix />
        </div>
        <div>
          <LogisticsStatsPageSeven />
        </div>
        <div>
          <LogisticsStatsPageEight />
        </div>
        <div>
          <LogisticsStatsPageNine />
        </div>
      </Slider>
    </TeamStatsLayout>
  );
};
export default LogisticsTeamStats;
